module.exports = __webpack_public_path__ + "img/calendar-empty-ultrathin-page.4e31041c.svg";